var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-footer footer"},[_c('div',{staticClass:"content-footer"},[_c('div',{staticClass:"eventos-footer"},[_c('div',{staticClass:"logo-footer"},[_c('a',[_c('img',{attrs:{"src":require("./../assets/ecbr.png")}})])])]),_c('div',{staticClass:"div-contato-footer"},[_c('p',[_vm._v("revista@ecommercebrasil.com.br")])])])])
}]

export { render, staticRenderFns }